module.exports = __webpack_public_path__ + "product_search-b2a17ee3799ad387e281cec4ee2ffc98.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/common/onboarding/product_search.png
// module id = 1142
// module chunks = 0 1 2 3 4